export default __webpack_public_path__ + "static/media/251.048778e7.gif";